import { StyleSheet } from 'react-native';
import { CELEBRATION_COLORS } from '../../constants/celebrations.constants';

// Colors are design-system constants (celebration design file), not theme-derived.
export const getXpGainFlashStyles = () =>
  StyleSheet.create({
    wrap: {
      position: 'absolute',
      left: 0,
      right: 0,
      alignItems: 'center',
      zIndex: 1000,
      elevation: 12,
    },
    pill: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 5,
      paddingVertical: 6,
      paddingHorizontal: 12,
      borderRadius: 999,
      backgroundColor: CELEBRATION_COLORS.SURFACE,
      borderWidth: 1,
      borderColor: 'rgba(110,231,183,0.35)',
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.4,
      shadowRadius: 8,
      elevation: 10,
    },
    amount: {
      fontSize: 15,
      fontWeight: '800',
      color: CELEBRATION_COLORS.MINT,
      fontVariant: ['tabular-nums'],
    },
    unit: {
      fontSize: 11,
      fontWeight: '700',
      letterSpacing: 0.8,
      color: CELEBRATION_COLORS.MUTED,
    },
  });
